/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * rain/v1/agent_service.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  AgentServiceDuplicateAgentBody,
  AgentServiceExportAgentBody,
  AgentServiceRestoreAgentVersionBody,
  AgentServiceTagAgentVersionBody,
  AgentServiceUpdateAgentBody,
  AgentServiceUpdateThreadAgentCardBody,
  RpcStatus,
  V1CreateAgentRequest,
  V1CreateAgentResponse,
  V1DuplicateAgentResponse,
  V1ExportAgentResponse,
  V1FilterSchemaResponse,
  V1GetAgentResponse,
  V1GetConfigSchemaResponse,
  V1GetDynamicExportFormatConfigSchemaRequest,
  V1GetDynamicImportFormatConfigSchemaRequest,
  V1ImportAgentRequest,
  V1ImportAgentResponse,
  V1ListAgentLabelsResponse,
  V1ListAgentVersionsResponse,
  V1ListAgentsResponse,
  V1ListExportFormatKindsResponse,
  V1ListImportFormatKindsResponse,
  V1RestoreAgentVersionResponse,
  V1ThreadAgentCardResponse,
  V1UpdateAgentResponse,
  WorkspaceDeleteAgent200,
  WorkspaceDeleteAgentParams,
  WorkspaceGetAgentParams,
  WorkspaceGetAgentVersionByTagParams,
  WorkspaceGetAgentVersionParams,
  WorkspaceGetFilterSchemaParams,
  WorkspaceGetStaticExportFormatConfigSchemaParams,
  WorkspaceGetStaticImportFormatConfigSchemaParams,
  WorkspaceGetThreadAgentCardParams,
  WorkspaceListAgentLabelsParams,
  WorkspaceListAgentVersionsParams,
  WorkspaceListAgentsParams,
  WorkspaceTagAgentVersion200,
  WorkspaceUntagAgentVersion200,
  WorkspaceUntagAgentVersionParams,
} from '../../models';

/**
 * Returns the IDs of agents that have been saved to disk.
Agents that exist only in memory (not yet saved) are not included.
 * @summary Lists all persisted agent IDs.
 */
export const workspaceListAgents = (
  organization: string,
  workspace: string,
  params?: WorkspaceListAgentsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListAgentsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceListAgentsQueryKey = (
  organization?: string,
  workspace?: string,
  params?: WorkspaceListAgentsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceListAgentsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListAgents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceListAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAgents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListAgentsQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListAgents>>
  > = ({ signal }) =>
    workspaceListAgents(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListAgents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListAgentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListAgents>>
>;
export type WorkspaceListAgentsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListAgents<
  TData = Awaited<ReturnType<typeof workspaceListAgents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | WorkspaceListAgentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListAgents>>,
          TError,
          Awaited<ReturnType<typeof workspaceListAgents>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListAgents<
  TData = Awaited<ReturnType<typeof workspaceListAgents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceListAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListAgents>>,
          TError,
          Awaited<ReturnType<typeof workspaceListAgents>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListAgents<
  TData = Awaited<ReturnType<typeof workspaceListAgents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceListAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAgents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all persisted agent IDs.
 */

export function useWorkspaceListAgents<
  TData = Awaited<ReturnType<typeof workspaceListAgents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceListAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAgents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListAgentsQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The agent ID is derived from the name (lowercase, dashed, URL-friendly).
 * @summary ============================================================================
CRUD Operations
============================================================================
Creates a new agent with the given name.
 */
export const workspaceCreateAgent = (
  organization: string,
  workspace: string,
  v1CreateAgentRequest: V1CreateAgentRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CreateAgentResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents`,
    v1CreateAgentRequest,
    options,
  );
};

export const getWorkspaceCreateAgentMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceCreateAgent>>,
    TError,
    { organization: string; workspace: string; data: V1CreateAgentRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceCreateAgent>>,
  TError,
  { organization: string; workspace: string; data: V1CreateAgentRequest },
  TContext
> => {
  const mutationKey = ['workspaceCreateAgent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceCreateAgent>>,
    { organization: string; workspace: string; data: V1CreateAgentRequest }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return workspaceCreateAgent(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceCreateAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceCreateAgent>>
>;
export type WorkspaceCreateAgentMutationBody = V1CreateAgentRequest;
export type WorkspaceCreateAgentMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
CRUD Operations
============================================================================
Creates a new agent with the given name.
 */
export const useWorkspaceCreateAgent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceCreateAgent>>,
      TError,
      { organization: string; workspace: string; data: V1CreateAgentRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceCreateAgent>>,
  TError,
  { organization: string; workspace: string; data: V1CreateAgentRequest },
  TContext
> => {
  const mutationOptions = getWorkspaceCreateAgentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists all available export format kinds and their configuration schemas.
 */
export const workspaceListExportFormatKinds = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListExportFormatKindsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/export-formats/kinds`,
    options,
  );
};

export const getWorkspaceListExportFormatKindsQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/export-formats/kinds`,
  ] as const;
};

export const getWorkspaceListExportFormatKindsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListExportFormatKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListExportFormatKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListExportFormatKindsQueryKey(organization, workspace);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListExportFormatKinds>>
  > = ({ signal }) =>
    workspaceListExportFormatKinds(organization, workspace, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListExportFormatKinds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListExportFormatKindsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListExportFormatKinds>>
>;
export type WorkspaceListExportFormatKindsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListExportFormatKinds<
  TData = Awaited<ReturnType<typeof workspaceListExportFormatKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListExportFormatKinds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListExportFormatKinds>>,
          TError,
          Awaited<ReturnType<typeof workspaceListExportFormatKinds>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListExportFormatKinds<
  TData = Awaited<ReturnType<typeof workspaceListExportFormatKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListExportFormatKinds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListExportFormatKinds>>,
          TError,
          Awaited<ReturnType<typeof workspaceListExportFormatKinds>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListExportFormatKinds<
  TData = Awaited<ReturnType<typeof workspaceListExportFormatKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListExportFormatKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all available export format kinds and their configuration schemas.
 */

export function useWorkspaceListExportFormatKinds<
  TData = Awaited<ReturnType<typeof workspaceListExportFormatKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListExportFormatKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListExportFormatKindsQueryOptions(
    organization,
    workspace,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Dynamic (layer-2) config schema for an export format kind.
 */
export const workspaceGetDynamicExportFormatConfigSchema = (
  organization: string,
  workspace: string,
  v1GetDynamicExportFormatConfigSchemaRequest: V1GetDynamicExportFormatConfigSchemaRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetConfigSchemaResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/export-formats:dynamic-config`,
    v1GetDynamicExportFormatConfigSchemaRequest,
    options,
  );
};

export const getWorkspaceGetDynamicExportFormatConfigSchemaMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceGetDynamicExportFormatConfigSchema>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: V1GetDynamicExportFormatConfigSchemaRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceGetDynamicExportFormatConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: V1GetDynamicExportFormatConfigSchemaRequest;
  },
  TContext
> => {
  const mutationKey = ['workspaceGetDynamicExportFormatConfigSchema'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceGetDynamicExportFormatConfigSchema>>,
    {
      organization: string;
      workspace: string;
      data: V1GetDynamicExportFormatConfigSchemaRequest;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return workspaceGetDynamicExportFormatConfigSchema(
      organization,
      workspace,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceGetDynamicExportFormatConfigSchemaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof workspaceGetDynamicExportFormatConfigSchema>>
  >;
export type WorkspaceGetDynamicExportFormatConfigSchemaMutationBody =
  V1GetDynamicExportFormatConfigSchemaRequest;
export type WorkspaceGetDynamicExportFormatConfigSchemaMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Dynamic (layer-2) config schema for an export format kind.
 */
export const useWorkspaceGetDynamicExportFormatConfigSchema = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceGetDynamicExportFormatConfigSchema>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: V1GetDynamicExportFormatConfigSchemaRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceGetDynamicExportFormatConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: V1GetDynamicExportFormatConfigSchemaRequest;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceGetDynamicExportFormatConfigSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Static (layer-1) config schema for an export format kind.
 */
export const workspaceGetStaticExportFormatConfigSchema = (
  organization: string,
  workspace: string,
  params: WorkspaceGetStaticExportFormatConfigSchemaParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetConfigSchemaResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/export-formats:static-config`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetStaticExportFormatConfigSchemaQueryKey = (
  organization?: string,
  workspace?: string,
  params?: WorkspaceGetStaticExportFormatConfigSchemaParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/export-formats:static-config`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetStaticExportFormatConfigSchemaQueryOptions = <
  TData = Awaited<
    ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: WorkspaceGetStaticExportFormatConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetStaticExportFormatConfigSchemaQueryKey(
      organization,
      workspace,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>>
  > = ({ signal }) =>
    workspaceGetStaticExportFormatConfigSchema(
      organization,
      workspace,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetStaticExportFormatConfigSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>>
>;
export type WorkspaceGetStaticExportFormatConfigSchemaQueryError =
  AxiosError<RpcStatus>;

export function useWorkspaceGetStaticExportFormatConfigSchema<
  TData = Awaited<
    ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: WorkspaceGetStaticExportFormatConfigSchemaParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>
          >,
          TError,
          Awaited<ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetStaticExportFormatConfigSchema<
  TData = Awaited<
    ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: WorkspaceGetStaticExportFormatConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>
          >,
          TError,
          Awaited<ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetStaticExportFormatConfigSchema<
  TData = Awaited<
    ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: WorkspaceGetStaticExportFormatConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Static (layer-1) config schema for an export format kind.
 */

export function useWorkspaceGetStaticExportFormatConfigSchema<
  TData = Awaited<
    ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: WorkspaceGetStaticExportFormatConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticExportFormatConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getWorkspaceGetStaticExportFormatConfigSchemaQueryOptions(
      organization,
      workspace,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lists all available import format kinds and their configuration schemas.
 */
export const workspaceListImportFormatKinds = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListImportFormatKindsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/import-formats/kinds`,
    options,
  );
};

export const getWorkspaceListImportFormatKindsQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/import-formats/kinds`,
  ] as const;
};

export const getWorkspaceListImportFormatKindsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListImportFormatKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListImportFormatKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListImportFormatKindsQueryKey(organization, workspace);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListImportFormatKinds>>
  > = ({ signal }) =>
    workspaceListImportFormatKinds(organization, workspace, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListImportFormatKinds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListImportFormatKindsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListImportFormatKinds>>
>;
export type WorkspaceListImportFormatKindsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListImportFormatKinds<
  TData = Awaited<ReturnType<typeof workspaceListImportFormatKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListImportFormatKinds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListImportFormatKinds>>,
          TError,
          Awaited<ReturnType<typeof workspaceListImportFormatKinds>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListImportFormatKinds<
  TData = Awaited<ReturnType<typeof workspaceListImportFormatKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListImportFormatKinds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListImportFormatKinds>>,
          TError,
          Awaited<ReturnType<typeof workspaceListImportFormatKinds>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListImportFormatKinds<
  TData = Awaited<ReturnType<typeof workspaceListImportFormatKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListImportFormatKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all available import format kinds and their configuration schemas.
 */

export function useWorkspaceListImportFormatKinds<
  TData = Awaited<ReturnType<typeof workspaceListImportFormatKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListImportFormatKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListImportFormatKindsQueryOptions(
    organization,
    workspace,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Dynamic (layer-2) config schema for an import format kind.
 */
export const workspaceGetDynamicImportFormatConfigSchema = (
  organization: string,
  workspace: string,
  v1GetDynamicImportFormatConfigSchemaRequest: V1GetDynamicImportFormatConfigSchemaRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetConfigSchemaResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/import-formats:dynamic-config`,
    v1GetDynamicImportFormatConfigSchemaRequest,
    options,
  );
};

export const getWorkspaceGetDynamicImportFormatConfigSchemaMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceGetDynamicImportFormatConfigSchema>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: V1GetDynamicImportFormatConfigSchemaRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceGetDynamicImportFormatConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: V1GetDynamicImportFormatConfigSchemaRequest;
  },
  TContext
> => {
  const mutationKey = ['workspaceGetDynamicImportFormatConfigSchema'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceGetDynamicImportFormatConfigSchema>>,
    {
      organization: string;
      workspace: string;
      data: V1GetDynamicImportFormatConfigSchemaRequest;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return workspaceGetDynamicImportFormatConfigSchema(
      organization,
      workspace,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceGetDynamicImportFormatConfigSchemaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof workspaceGetDynamicImportFormatConfigSchema>>
  >;
export type WorkspaceGetDynamicImportFormatConfigSchemaMutationBody =
  V1GetDynamicImportFormatConfigSchemaRequest;
export type WorkspaceGetDynamicImportFormatConfigSchemaMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Dynamic (layer-2) config schema for an import format kind.
 */
export const useWorkspaceGetDynamicImportFormatConfigSchema = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceGetDynamicImportFormatConfigSchema>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: V1GetDynamicImportFormatConfigSchemaRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceGetDynamicImportFormatConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: V1GetDynamicImportFormatConfigSchemaRequest;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceGetDynamicImportFormatConfigSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Static (layer-1) config schema for an import format kind.
 */
export const workspaceGetStaticImportFormatConfigSchema = (
  organization: string,
  workspace: string,
  params: WorkspaceGetStaticImportFormatConfigSchemaParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetConfigSchemaResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/import-formats:static-config`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetStaticImportFormatConfigSchemaQueryKey = (
  organization?: string,
  workspace?: string,
  params?: WorkspaceGetStaticImportFormatConfigSchemaParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/import-formats:static-config`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetStaticImportFormatConfigSchemaQueryOptions = <
  TData = Awaited<
    ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: WorkspaceGetStaticImportFormatConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetStaticImportFormatConfigSchemaQueryKey(
      organization,
      workspace,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>>
  > = ({ signal }) =>
    workspaceGetStaticImportFormatConfigSchema(
      organization,
      workspace,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetStaticImportFormatConfigSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>>
>;
export type WorkspaceGetStaticImportFormatConfigSchemaQueryError =
  AxiosError<RpcStatus>;

export function useWorkspaceGetStaticImportFormatConfigSchema<
  TData = Awaited<
    ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: WorkspaceGetStaticImportFormatConfigSchemaParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>
          >,
          TError,
          Awaited<ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetStaticImportFormatConfigSchema<
  TData = Awaited<
    ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: WorkspaceGetStaticImportFormatConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>
          >,
          TError,
          Awaited<ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetStaticImportFormatConfigSchema<
  TData = Awaited<
    ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: WorkspaceGetStaticImportFormatConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Static (layer-1) config schema for an import format kind.
 */

export function useWorkspaceGetStaticImportFormatConfigSchema<
  TData = Awaited<
    ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: WorkspaceGetStaticImportFormatConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticImportFormatConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getWorkspaceGetStaticImportFormatConfigSchemaQueryOptions(
      organization,
      workspace,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the agent's ID and display name.
Use other service methods to get detailed information like memory blocks.
 * @summary Gets an agent's metadata.
 */
export const workspaceGetAgent = (
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceGetAgentParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetAgentResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetAgentQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  params?: WorkspaceGetAgentParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetAgentQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetAgent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceGetAgentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetAgent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetAgentQueryKey(organization, workspace, agentId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetAgent>>
  > = ({ signal }) =>
    workspaceGetAgent(organization, workspace, agentId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetAgent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetAgentQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetAgent>>
>;
export type WorkspaceGetAgentQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetAgent<
  TData = Awaited<ReturnType<typeof workspaceGetAgent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: undefined | WorkspaceGetAgentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetAgent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetAgent>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetAgent>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetAgent<
  TData = Awaited<ReturnType<typeof workspaceGetAgent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceGetAgentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetAgent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetAgent>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetAgent>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetAgent<
  TData = Awaited<ReturnType<typeof workspaceGetAgent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceGetAgentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetAgent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets an agent's metadata.
 */

export function useWorkspaceGetAgent<
  TData = Awaited<ReturnType<typeof workspaceGetAgent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceGetAgentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetAgent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetAgentQueryOptions(
    organization,
    workspace,
    agentId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This removes the agent completely. The operation cannot be undone.
 * @summary Deletes an agent from both memory and disk.
 */
export const workspaceDeleteAgent = (
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceDeleteAgentParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceDeleteAgent200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceDeleteAgentMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDeleteAgent>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      params?: WorkspaceDeleteAgentParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDeleteAgent>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    params?: WorkspaceDeleteAgentParams;
  },
  TContext
> => {
  const mutationKey = ['workspaceDeleteAgent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDeleteAgent>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      params?: WorkspaceDeleteAgentParams;
    }
  > = props => {
    const { organization, workspace, agentId, params } = props ?? {};

    return workspaceDeleteAgent(
      organization,
      workspace,
      agentId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDeleteAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDeleteAgent>>
>;

export type WorkspaceDeleteAgentMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes an agent from both memory and disk.
 */
export const useWorkspaceDeleteAgent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDeleteAgent>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        params?: WorkspaceDeleteAgentParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDeleteAgent>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    params?: WorkspaceDeleteAgentParams;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceDeleteAgentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Supports updating the display name and the label set.
 * @summary Updates an agent's metadata.
 */
export const workspaceUpdateAgent = (
  organization: string,
  workspace: string,
  agentId: string,
  agentServiceUpdateAgentBody: AgentServiceUpdateAgentBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UpdateAgentResponse>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}`,
    agentServiceUpdateAgentBody,
    options,
  );
};

export const getWorkspaceUpdateAgentMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceUpdateAgent>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: AgentServiceUpdateAgentBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceUpdateAgent>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: AgentServiceUpdateAgentBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceUpdateAgent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceUpdateAgent>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: AgentServiceUpdateAgentBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceUpdateAgent(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceUpdateAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceUpdateAgent>>
>;
export type WorkspaceUpdateAgentMutationBody = AgentServiceUpdateAgentBody;
export type WorkspaceUpdateAgentMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates an agent's metadata.
 */
export const useWorkspaceUpdateAgent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceUpdateAgent>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: AgentServiceUpdateAgentBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceUpdateAgent>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: AgentServiceUpdateAgentBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceUpdateAgentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Fetches a specific version of an agent's full configuration by tag name.
 */
export const workspaceGetAgentVersionByTag = (
  organization: string,
  workspace: string,
  agentId: string,
  tag: string,
  params?: WorkspaceGetAgentVersionByTagParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetAgentResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/tags/${tag}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetAgentVersionByTagQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  tag?: string,
  params?: WorkspaceGetAgentVersionByTagParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/tags/${tag}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetAgentVersionByTagQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  tag: string,
  params?: WorkspaceGetAgentVersionByTagParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetAgentVersionByTagQueryKey(
      organization,
      workspace,
      agentId,
      tag,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>
  > = ({ signal }) =>
    workspaceGetAgentVersionByTag(
      organization,
      workspace,
      agentId,
      tag,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && tag),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetAgentVersionByTagQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>
>;
export type WorkspaceGetAgentVersionByTagQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetAgentVersionByTag<
  TData = Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  tag: string,
  params: undefined | WorkspaceGetAgentVersionByTagParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetAgentVersionByTag<
  TData = Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  tag: string,
  params?: WorkspaceGetAgentVersionByTagParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetAgentVersionByTag<
  TData = Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  tag: string,
  params?: WorkspaceGetAgentVersionByTagParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetches a specific version of an agent's full configuration by tag name.
 */

export function useWorkspaceGetAgentVersionByTag<
  TData = Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  tag: string,
  params?: WorkspaceGetAgentVersionByTagParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetAgentVersionByTag>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetAgentVersionByTagQueryOptions(
    organization,
    workspace,
    agentId,
    tag,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Removes a tag from an agent.
 */
export const workspaceUntagAgentVersion = (
  organization: string,
  workspace: string,
  agentId: string,
  tag: string,
  params?: WorkspaceUntagAgentVersionParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceUntagAgentVersion200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/tags/${tag}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceUntagAgentVersionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceUntagAgentVersion>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      tag: string;
      params?: WorkspaceUntagAgentVersionParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceUntagAgentVersion>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    tag: string;
    params?: WorkspaceUntagAgentVersionParams;
  },
  TContext
> => {
  const mutationKey = ['workspaceUntagAgentVersion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceUntagAgentVersion>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      tag: string;
      params?: WorkspaceUntagAgentVersionParams;
    }
  > = props => {
    const { organization, workspace, agentId, tag, params } = props ?? {};

    return workspaceUntagAgentVersion(
      organization,
      workspace,
      agentId,
      tag,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceUntagAgentVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceUntagAgentVersion>>
>;

export type WorkspaceUntagAgentVersionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Removes a tag from an agent.
 */
export const useWorkspaceUntagAgentVersion = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceUntagAgentVersion>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        tag: string;
        params?: WorkspaceUntagAgentVersionParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceUntagAgentVersion>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    tag: string;
    params?: WorkspaceUntagAgentVersionParams;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceUntagAgentVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Reads a thread's effective agent-card settings (description, abilities,
and feature toggles), resolved against the base agent.
 */
export const workspaceGetThreadAgentCard = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadAgentCardParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ThreadAgentCardResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/card`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetThreadAgentCardQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceGetThreadAgentCardParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/card`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetThreadAgentCardQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadAgentCardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetThreadAgentCardQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>
  > = ({ signal }) =>
    workspaceGetThreadAgentCard(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetThreadAgentCardQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>
>;
export type WorkspaceGetThreadAgentCardQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetThreadAgentCard<
  TData = Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceGetThreadAgentCardParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetThreadAgentCard<
  TData = Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadAgentCardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetThreadAgentCard<
  TData = Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadAgentCardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Reads a thread's effective agent-card settings (description, abilities,
and feature toggles), resolved against the base agent.
 */

export function useWorkspaceGetThreadAgentCard<
  TData = Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadAgentCardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadAgentCard>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetThreadAgentCardQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Sets a thread's agent-card settings. Writes to the thread's
configuration (not the base agent); Deploy promotes them.
 */
export const workspaceUpdateThreadAgentCard = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  agentServiceUpdateThreadAgentCardBody: AgentServiceUpdateThreadAgentCardBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ThreadAgentCardResponse>> => {
  return axios.default.put(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/card`,
    agentServiceUpdateThreadAgentCardBody,
    options,
  );
};

export const getWorkspaceUpdateThreadAgentCardMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceUpdateThreadAgentCard>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: AgentServiceUpdateThreadAgentCardBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceUpdateThreadAgentCard>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: AgentServiceUpdateThreadAgentCardBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceUpdateThreadAgentCard'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceUpdateThreadAgentCard>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: AgentServiceUpdateThreadAgentCardBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceUpdateThreadAgentCard(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceUpdateThreadAgentCardMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceUpdateThreadAgentCard>>
>;
export type WorkspaceUpdateThreadAgentCardMutationBody =
  AgentServiceUpdateThreadAgentCardBody;
export type WorkspaceUpdateThreadAgentCardMutationError = AxiosError<RpcStatus>;

/**
 * @summary Sets a thread's agent-card settings. Writes to the thread's
configuration (not the base agent); Deploy promotes them.
 */
export const useWorkspaceUpdateThreadAgentCard = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceUpdateThreadAgentCard>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: AgentServiceUpdateThreadAgentCardBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceUpdateThreadAgentCard>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: AgentServiceUpdateThreadAgentCardBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceUpdateThreadAgentCardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns version metadata in ascending order.
 * @summary ============================================================================
Version History
============================================================================
Lists all versions of an agent.
 */
export const workspaceListAgentVersions = (
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceListAgentVersionsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListAgentVersionsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/versions`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceListAgentVersionsQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  params?: WorkspaceListAgentVersionsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/versions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceListAgentVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListAgentVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceListAgentVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAgentVersions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListAgentVersionsQueryKey(
      organization,
      workspace,
      agentId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListAgentVersions>>
  > = ({ signal }) =>
    workspaceListAgentVersions(organization, workspace, agentId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListAgentVersions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListAgentVersionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListAgentVersions>>
>;
export type WorkspaceListAgentVersionsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListAgentVersions<
  TData = Awaited<ReturnType<typeof workspaceListAgentVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: undefined | WorkspaceListAgentVersionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAgentVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListAgentVersions>>,
          TError,
          Awaited<ReturnType<typeof workspaceListAgentVersions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListAgentVersions<
  TData = Awaited<ReturnType<typeof workspaceListAgentVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceListAgentVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAgentVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListAgentVersions>>,
          TError,
          Awaited<ReturnType<typeof workspaceListAgentVersions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListAgentVersions<
  TData = Awaited<ReturnType<typeof workspaceListAgentVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceListAgentVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAgentVersions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Version History
============================================================================
Lists all versions of an agent.
 */

export function useWorkspaceListAgentVersions<
  TData = Awaited<ReturnType<typeof workspaceListAgentVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceListAgentVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAgentVersions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListAgentVersionsQueryOptions(
    organization,
    workspace,
    agentId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Fetches a specific version of an agent's full configuration by version number.
 */
export const workspaceGetAgentVersion = (
  organization: string,
  workspace: string,
  agentId: string,
  version: string,
  params?: WorkspaceGetAgentVersionParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetAgentResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/versions/${version}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetAgentVersionQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  version?: string,
  params?: WorkspaceGetAgentVersionParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/versions/${version}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetAgentVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetAgentVersion>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  version: string,
  params?: WorkspaceGetAgentVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetAgentVersion>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetAgentVersionQueryKey(
      organization,
      workspace,
      agentId,
      version,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetAgentVersion>>
  > = ({ signal }) =>
    workspaceGetAgentVersion(
      organization,
      workspace,
      agentId,
      version,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && version),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetAgentVersion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetAgentVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetAgentVersion>>
>;
export type WorkspaceGetAgentVersionQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetAgentVersion<
  TData = Awaited<ReturnType<typeof workspaceGetAgentVersion>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  version: string,
  params: undefined | WorkspaceGetAgentVersionParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetAgentVersion>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetAgentVersion>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetAgentVersion>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetAgentVersion<
  TData = Awaited<ReturnType<typeof workspaceGetAgentVersion>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  version: string,
  params?: WorkspaceGetAgentVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetAgentVersion>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetAgentVersion>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetAgentVersion>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetAgentVersion<
  TData = Awaited<ReturnType<typeof workspaceGetAgentVersion>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  version: string,
  params?: WorkspaceGetAgentVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetAgentVersion>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Fetches a specific version of an agent's full configuration by version number.
 */

export function useWorkspaceGetAgentVersion<
  TData = Awaited<ReturnType<typeof workspaceGetAgentVersion>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  version: string,
  params?: WorkspaceGetAgentVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetAgentVersion>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetAgentVersionQueryOptions(
    organization,
    workspace,
    agentId,
    version,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The old version's template becomes the new latest version.
All existing versions are preserved.
 * @summary Restores a previous version as a new version at the head.
 */
export const workspaceRestoreAgentVersion = (
  organization: string,
  workspace: string,
  agentId: string,
  version: string,
  agentServiceRestoreAgentVersionBody: AgentServiceRestoreAgentVersionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RestoreAgentVersionResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/versions/${version}:restore`,
    agentServiceRestoreAgentVersionBody,
    options,
  );
};

export const getWorkspaceRestoreAgentVersionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceRestoreAgentVersion>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      version: string;
      data: AgentServiceRestoreAgentVersionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceRestoreAgentVersion>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    version: string;
    data: AgentServiceRestoreAgentVersionBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceRestoreAgentVersion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceRestoreAgentVersion>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      version: string;
      data: AgentServiceRestoreAgentVersionBody;
    }
  > = props => {
    const { organization, workspace, agentId, version, data } = props ?? {};

    return workspaceRestoreAgentVersion(
      organization,
      workspace,
      agentId,
      version,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceRestoreAgentVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceRestoreAgentVersion>>
>;
export type WorkspaceRestoreAgentVersionMutationBody =
  AgentServiceRestoreAgentVersionBody;
export type WorkspaceRestoreAgentVersionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Restores a previous version as a new version at the head.
 */
export const useWorkspaceRestoreAgentVersion = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceRestoreAgentVersion>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        version: string;
        data: AgentServiceRestoreAgentVersionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceRestoreAgentVersion>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    version: string;
    data: AgentServiceRestoreAgentVersionBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceRestoreAgentVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Tags are immutable — a tag name can only be used once per agent.
To reassign a tag, untag it first, then re-tag.
 * @summary Applies a tag to a specific agent version.
 */
export const workspaceTagAgentVersion = (
  organization: string,
  workspace: string,
  agentId: string,
  version: string,
  agentServiceTagAgentVersionBody: AgentServiceTagAgentVersionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceTagAgentVersion200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/versions/${version}:tag`,
    agentServiceTagAgentVersionBody,
    options,
  );
};

export const getWorkspaceTagAgentVersionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceTagAgentVersion>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      version: string;
      data: AgentServiceTagAgentVersionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceTagAgentVersion>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    version: string;
    data: AgentServiceTagAgentVersionBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceTagAgentVersion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceTagAgentVersion>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      version: string;
      data: AgentServiceTagAgentVersionBody;
    }
  > = props => {
    const { organization, workspace, agentId, version, data } = props ?? {};

    return workspaceTagAgentVersion(
      organization,
      workspace,
      agentId,
      version,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceTagAgentVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceTagAgentVersion>>
>;
export type WorkspaceTagAgentVersionMutationBody =
  AgentServiceTagAgentVersionBody;
export type WorkspaceTagAgentVersionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Applies a tag to a specific agent version.
 */
export const useWorkspaceTagAgentVersion = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceTagAgentVersion>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        version: string;
        data: AgentServiceTagAgentVersionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceTagAgentVersion>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    version: string;
    data: AgentServiceTagAgentVersionBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceTagAgentVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Creates a new agent that is a complete copy of the source agent,
including generator, memory blocks, tool sources with adapters,
artifact stores, artifact types, event compactor, and variables.
 * @summary Duplicates an agent with all its configuration.
 */
export const workspaceDuplicateAgent = (
  organization: string,
  workspace: string,
  agentId: string,
  agentServiceDuplicateAgentBody: AgentServiceDuplicateAgentBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DuplicateAgentResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}:duplicate`,
    agentServiceDuplicateAgentBody,
    options,
  );
};

export const getWorkspaceDuplicateAgentMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDuplicateAgent>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: AgentServiceDuplicateAgentBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDuplicateAgent>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: AgentServiceDuplicateAgentBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceDuplicateAgent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDuplicateAgent>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: AgentServiceDuplicateAgentBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceDuplicateAgent(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDuplicateAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDuplicateAgent>>
>;
export type WorkspaceDuplicateAgentMutationBody =
  AgentServiceDuplicateAgentBody;
export type WorkspaceDuplicateAgentMutationError = AxiosError<RpcStatus>;

/**
 * @summary Duplicates an agent with all its configuration.
 */
export const useWorkspaceDuplicateAgent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDuplicateAgent>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: AgentServiceDuplicateAgentBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDuplicateAgent>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: AgentServiceDuplicateAgentBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceDuplicateAgentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns the exported data as bytes with a suggested filename.
 * @summary ============================================================================
Export/Import Operations
============================================================================
Exports an agent configuration in the specified format.
 */
export const workspaceExportAgent = (
  organization: string,
  workspace: string,
  agentId: string,
  agentServiceExportAgentBody: AgentServiceExportAgentBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ExportAgentResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}:export`,
    agentServiceExportAgentBody,
    options,
  );
};

export const getWorkspaceExportAgentMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceExportAgent>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: AgentServiceExportAgentBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceExportAgent>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: AgentServiceExportAgentBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceExportAgent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceExportAgent>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: AgentServiceExportAgentBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceExportAgent(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceExportAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceExportAgent>>
>;
export type WorkspaceExportAgentMutationBody = AgentServiceExportAgentBody;
export type WorkspaceExportAgentMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Export/Import Operations
============================================================================
Exports an agent configuration in the specified format.
 */
export const useWorkspaceExportAgent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceExportAgent>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: AgentServiceExportAgentBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceExportAgent>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: AgentServiceExportAgentBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceExportAgentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary The agent listing's discovered filter schema: filterable fields with
operators, value types, and in-scope values with counts. `query` scopes
the counts; the active filter is not an input.
 */
export const workspaceGetFilterSchema = (
  organization: string,
  workspace: string,
  params?: WorkspaceGetFilterSchemaParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1FilterSchemaResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents:filter-schema`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetFilterSchemaQueryKey = (
  organization?: string,
  workspace?: string,
  params?: WorkspaceGetFilterSchemaParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents:filter-schema`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetFilterSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetFilterSchemaQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetFilterSchema>>
  > = ({ signal }) =>
    workspaceGetFilterSchema(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetFilterSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetFilterSchema>>
>;
export type WorkspaceGetFilterSchemaQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetFilterSchema<
  TData = Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | WorkspaceGetFilterSchemaParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetFilterSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetFilterSchema<
  TData = Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetFilterSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetFilterSchema<
  TData = Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary The agent listing's discovered filter schema: filterable fields with
operators, value types, and in-scope values with counts. `query` scopes
the counts; the active filter is not an input.
 */

export function useWorkspaceGetFilterSchema<
  TData = Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetFilterSchemaQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Parses and validates the data, saves the agent to the store.
Sub-agent dependencies must exist or be included in the import bundle.
 * @summary Imports an agent configuration from the specified format.
 */
export const workspaceImportAgent = (
  organization: string,
  workspace: string,
  v1ImportAgentRequest: V1ImportAgentRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ImportAgentResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents:import`,
    v1ImportAgentRequest,
    options,
  );
};

export const getWorkspaceImportAgentMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceImportAgent>>,
    TError,
    { organization: string; workspace: string; data: V1ImportAgentRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceImportAgent>>,
  TError,
  { organization: string; workspace: string; data: V1ImportAgentRequest },
  TContext
> => {
  const mutationKey = ['workspaceImportAgent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceImportAgent>>,
    { organization: string; workspace: string; data: V1ImportAgentRequest }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return workspaceImportAgent(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceImportAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceImportAgent>>
>;
export type WorkspaceImportAgentMutationBody = V1ImportAgentRequest;
export type WorkspaceImportAgentMutationError = AxiosError<RpcStatus>;

/**
 * @summary Imports an agent configuration from the specified format.
 */
export const useWorkspaceImportAgent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceImportAgent>>,
      TError,
      { organization: string; workspace: string; data: V1ImportAgentRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceImportAgent>>,
  TError,
  { organization: string; workspace: string; data: V1ImportAgentRequest },
  TContext
> => {
  const mutationOptions = getWorkspaceImportAgentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Backs a label editor's autocomplete, so a user is nudged toward reusing
an existing label rather than introducing a near-duplicate spelling.
 * @summary Lists every label in use across the parent scope, de-duplicated
case-insensitively.
 */
export const workspaceListAgentLabels = (
  organization: string,
  workspace: string,
  params?: WorkspaceListAgentLabelsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListAgentLabelsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents:labels`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceListAgentLabelsQueryKey = (
  organization?: string,
  workspace?: string,
  params?: WorkspaceListAgentLabelsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents:labels`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceListAgentLabelsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListAgentLabels>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceListAgentLabelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAgentLabels>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListAgentLabelsQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListAgentLabels>>
  > = ({ signal }) =>
    workspaceListAgentLabels(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListAgentLabels>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListAgentLabelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListAgentLabels>>
>;
export type WorkspaceListAgentLabelsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListAgentLabels<
  TData = Awaited<ReturnType<typeof workspaceListAgentLabels>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | WorkspaceListAgentLabelsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAgentLabels>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListAgentLabels>>,
          TError,
          Awaited<ReturnType<typeof workspaceListAgentLabels>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListAgentLabels<
  TData = Awaited<ReturnType<typeof workspaceListAgentLabels>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceListAgentLabelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAgentLabels>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListAgentLabels>>,
          TError,
          Awaited<ReturnType<typeof workspaceListAgentLabels>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListAgentLabels<
  TData = Awaited<ReturnType<typeof workspaceListAgentLabels>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceListAgentLabelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAgentLabels>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists every label in use across the parent scope, de-duplicated
case-insensitively.
 */

export function useWorkspaceListAgentLabels<
  TData = Awaited<ReturnType<typeof workspaceListAgentLabels>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceListAgentLabelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAgentLabels>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListAgentLabelsQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
